import { useMantineColorScheme } from "@mantine/core"
import { SVGProps } from "react"
import { JSX } from "react/jsx-runtime"

import { useSvgStyle } from "./useSvgStyle"

export function CsvSvgComponent(
  props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      width="50px"
      height="50px"
      viewBox="-4 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.106 0A5.074 5.074 0 00.033 5.074v53.841a5.073 5.073 0 005.073 5.074H50.88a5.074 5.074 0 005.074-5.074V20.31L37.051 0H5.106z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#45B058"
      />
      <path
        d="M20.306 43.197a.784.784 0 01.198.522c0 .378-.306.72-.703.72a.638.638 0 01-.504-.234c-.702-.846-1.891-1.387-3.007-1.387-2.629 0-4.627 2.017-4.627 4.88 0 2.845 1.999 4.879 4.627 4.879a3.97 3.97 0 003.007-1.369.697.697 0 01.504-.233c.415 0 .703.359.703.738 0 .18-.072.36-.198.504-.937.972-2.215 1.693-4.015 1.693-3.457 0-6.176-2.521-6.176-6.212s2.719-6.212 6.176-6.212c1.8.001 3.096.721 4.015 1.711zm6.802 10.714c-1.782 0-3.187-.594-4.213-1.495a.71.71 0 01-.234-.54c0-.361.27-.757.702-.757.144 0 .306.036.432.144.828.739 1.98 1.314 3.367 1.314 2.143 0 2.827-1.152 2.827-2.071 0-3.097-7.112-1.386-7.112-5.672 0-1.98 1.764-3.331 4.123-3.331 1.548 0 2.881.467 3.853 1.278a.73.73 0 01.252.54c0 .36-.306.72-.703.72a.68.68 0 01-.432-.162c-.882-.72-1.98-1.044-3.079-1.044-1.44 0-2.467.774-2.467 1.909 0 2.701 7.112 1.152 7.112 5.636.001 1.748-1.187 3.531-4.428 3.531zm16.994-11.254l-4.159 10.335a1.31 1.31 0 01-1.188.81h-.036a1.316 1.316 0 01-1.207-.81L33.37 42.657a.746.746 0 01-.054-.288c0-.36.323-.793.81-.793.306 0 .594.18.72.486l3.889 9.992 3.889-9.992a.767.767 0 01.72-.486.803.803 0 01.758 1.081z"
        fill="#fff"
      />
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          d="M56.001 20.357v1h-12.8s-6.312-1.26-6.128-6.707c0 0 .208 5.707 6.003 5.707h12.925z"
          fill="#349C42"
        />
        <path
          d="M37.098.006v14.561c0 1.656 1.104 5.791 6.104 5.791h12.8L37.098.006z"
          opacity={0.5}
          fill="#fff"
        />
      </g>
    </svg>
  )
}

export function GsheetSvgComponent(
  props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>,
) {
  const { fill } = useSvgStyle()
  return (
    <svg
      fill={fill}
      height="50px"
      width="50px"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 204.376 204.376"
      xmlSpace="preserve"
      {...props}
    >
      <path d="M171.247 204.376a4.5 4.5 0 004.5-4.5V61.35h-51.744c-7.502 0-13.605-6.107-13.605-13.614V0H33.13a4.5 4.5 0 00-4.5 4.5v195.376a4.5 4.5 0 004.5 4.5h138.117zM52.891 87.627h99.717v80H52.891v-80zm53.858 56.333h37.858v15.667h-37.858V143.96zm-45.858-24.666h37.858v16.666H60.891v-16.666zm0 24.666h37.858v15.667H60.891V143.96zm45.858-48.333h37.858v15.667h-37.858V95.627zm0 23.667h37.858v16.666h-37.858v-16.666zM60.891 95.627h37.858v15.667H60.891V95.627zm59.506-47.891v-37.34L164.2 51.35h-40.197a3.614 3.614 0 01-3.606-3.614z" />
    </svg>
  )
}

export function DatadogSvgComponent(
  props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>,
) {
  const { colorScheme } = useMantineColorScheme()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? 50}
      height={props.height ?? 50}
      viewBox="0 0 64.6 69"
      preserveAspectRatio="xMidYMid meet"
      {...props}
      fill={colorScheme === "dark" ? "#fff" : "#000"}
    >
      <defs>
        <mask
          id="A"
          height="69"
          width="64.6"
          y="0"
          x=".1"
          maskUnits="userSpaceOnUse"
        >
          <g filter="url(#E)">
            <path d="M64.8 0H.1v69h64.7z" fill="#fff" />
          </g>
        </mask>
        <filter
          height="12.7"
          width="11.5"
          y=".1"
          x="0"
          filterUnits="userSpaceOnUse"
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
        <filter
          height="12.9"
          width="10.6"
          y=".2"
          x=".1"
          filterUnits="userSpaceOnUse"
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
        <filter
          height="12.9"
          width="12.7"
          y=".2"
          x="0"
          filterUnits="userSpaceOnUse"
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
        <filter
          height="69"
          width="64.6"
          y="0"
          x=".1"
          filterUnits="userSpaceOnUse"
          id="E"
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <g fill={props.color ?? "#5c2d90"}>
        <path
          d="M57.705 33.717l1.575 20.1L31.4 58.82 29 38.72l3.983-.556c.648.278 1.112.37 1.853.556 1.204.278 2.594.648 4.63-.463.463-.278 1.482-1.112 1.853-1.667zm-43.073 23.9c-.463-.74-1.297-1.575-2.594-2.594-1.853-1.482-1.204-4.076-.093-5.65 1.4-2.686 8.707-6.206 8.337-10.56-.185-1.575-.37-3.613-1.853-5.095-.093.556 0 1.112 0 1.112s-.648-.74-.926-1.853c-.278-.37-.556-.556-.834-1.112-.185.648-.185 1.297-.185 1.297s-.463-1.204-.556-2.13c-.278.463-.37 1.297-.37 1.297s-.648-1.853-.463-2.87c-.278-.834-1.204-2.594-.926-6.484 1.575 1.112 5.095.834 6.484-1.204.463-.648.74-2.5-.185-6.114-.648-2.316-2.223-5.743-2.87-7.04l-.093.093c.37 1.02 1.02 3.242 1.297 4.354.74 3.242 1.02 4.354.648 5.836-.278 1.297-1.02 2.13-2.964 3.057-1.853.926-4.446-1.4-4.54-1.482-1.853-1.482-3.242-3.9-3.427-5.002-.185-1.297.74-2.038 1.204-3.057-.648.185-1.4.556-1.4.556s.834-.926 1.945-1.667a9.43 9.43 0 0 0 1.204-.834H10.28s1.112-.648 2.316-1.02H10.93l4.446-1.945c1.4-.556 2.686-.37 3.427.648 1.02 1.4 2.038 2.13 4.168 2.686 1.297-.556 1.76-.926 3.427-1.4 1.482-1.667 2.686-1.853 2.686-1.853s-.834.74-.926 1.575c.834-.648 1.76-1.204 1.76-1.204s-.37.463-.648 1.112l.093.093c1.02-.556 2.13-1.02 2.13-1.02s-.37.37-.74.926c.74 0 2.223 0 2.78.093 3.427.093 4.168-3.613 5.465-4.168 1.667-.556 2.408-.926 5.187 1.853 2.408 2.408 4.26 6.577 3.335 7.503-.74.74-2.316-.278-4.076-2.408-.926-1.112-1.575-2.5-1.945-4.168-.185-1.4-1.204-2.223-1.204-2.223s.648 1.4.648 2.594c0 .648.093 3.057 1.112 4.446-.093.185-.185 1.02-.278 1.112-1.204-1.482-3.9-2.5-4.26-2.87 1.482 1.204 4.817 3.9 6.114 6.484 1.204 2.5.463 4.724 1.112 5.28.185.185 2.594 3.15 3.057 4.724.834 2.686.093 5.465-1.02 7.132l-2.964.463a3.92 3.92 0 0 1-1.112-.371c.185-.37.648-1.297.648-1.482l-.185-.278c-.926 1.297-2.5 2.594-3.798 3.335-1.667.926-3.613.834-4.9.37-3.613-1.112-7.04-3.52-7.78-4.168 0 0 0 .463.093.648a28.07 28.07 0 0 0 5.002 4.168l-4.26.463 2.038 15.747c-.926.093-1.02.185-2.038.37-.834-3.057-2.5-5.002-4.354-6.206-1.575-1.02-3.798-1.297-5.928-.834l-.093.185c1.482-.185 3.242.093 5.002 1.204s3.15 3.983 3.705 5.65c.648 2.223 1.112 4.54-.648 7.04-1.297 1.76-5.002 2.78-7.966.648.834 1.297 1.853 2.316 3.335 2.5 2.13.278 4.168-.093 5.65-1.482 1.204-1.204 1.853-3.798 1.667-6.577l1.945-.278.648 4.9L62.06 56.7l-2.78-25.195-1.575.278L54.556 0 1.942 6.114l6.484 52.428z"
          mask="url(#A)"
        />
        <path d="M39.665 30.06c1.4 1.02 2.594 1.667 3.798 1.575.74-.093 1.482-1.297 1.945-2.408.37-.74.37-1.575-.185-1.853-.278-.093-1.4-.093-2.223 0-1.575.185-3.15.74-3.52 1.02-.556.37-.278 1.297.185 1.667m.37-10.84v.093l.093.185c.37.74.74 1.482 1.482 1.853.185 0 .37-.093.556-.093.648 0 1.02.093 1.297.185v-.556c-.093-.926.185-2.594-1.667-3.52-.74-.37-1.667-.185-2.038.185h.185c.463.185.185.37.093.556-.093.37-.185.463 0 1.112" />
        <path d="M31.698 19.407c.463-.37-2.13-.926-4.168.37-1.482 1.02-1.482 3.15-.093 4.354a1.27 1.27 0 0 1 .37.278c.37-.185.926-.37 1.4-.556.926-.278 1.667-.463 2.316-.556.278-.37.648-.926.556-1.945-.093-1.4-1.204-1.112-.37-1.945m15.098 22.5l-4.446 7.4-5.187-1.575-4.54 6.947.185 2.223 24.825-4.54-1.482-15.47-4.076 8.522z" />
      </g>
    </svg>
  )
}

export function AwsSvgComponent(
  props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>,
) {
  const { fill } = useSvgStyle()
  return (
    <svg
      width="50px"
      height="50px"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill={fill}
    >
      <g data-name="Layer 2">
        <g data-name="invisible box" fill="none">
          <path d="M0 0H48V48H0z" />
          <path d="M0 0H48V48H0z" />
        </g>
        <g data-name="icons Q2">
          <path d="M14.4 20.6a5.1 5.1 0 00.2 1.3l.4 1a.4.4 0 01.1.3c0 .2-.1.3-.2.5l-1 .6h-.3a.6.6 0 01-.5-.2 1.8 1.8 0 01-.5-.7 5.6 5.6 0 01-.5-.8 5.4 5.4 0 01-4.3 2 4 4 0 01-2.9-1.1 3.8 3.8 0 01-1.1-2.8 3.9 3.9 0 011.4-3 5.2 5.2 0 013.5-1.1h1.6l1.7.3V16a3.5 3.5 0 00-.7-2.3 3.8 3.8 0 00-2.4-.7l-1.6.2-1.6.5-.5.2H5c-.2 0-.3-.2-.3-.5v-.7a.7.7 0 01.1-.5l.4-.3a7.5 7.5 0 011.8-.6 9.1 9.1 0 012.3-.3 5.5 5.5 0 013.9 1.2 4.9 4.9 0 011.2 3.6v4.8zm-5.9 2.2l1.5-.3a4.2 4.2 0 001.4-.9 3.1 3.1 0 00.5-1c0-.3.1-.7.1-1.2v-.6l-1.3-.3H9.3a3.4 3.4 0 00-2.2.6 2.1 2.1 0 00-.7 1.7 2.1 2.1 0 00.5 1.5 2.1 2.1 0 001.6.5zm11.7 1.6a.6.6 0 01-.5-.2.9.9 0 01-.4-.6l-3.4-11.3a1.8 1.8 0 01-.1-.6.3.3 0 01.3-.3h2a1.6 1.6 0 01.3.6l2.5 9.7 2.3-9.7a.8.8 0 01.2-.6h2.4l.3.6 2.3 9.8 2.5-9.8.3-.6h1.9c.3 0 .4.1.4.3v.3c0 .1-.1.2-.1.3l-3.6 11.4a.6.6 0 01-.3.5l-.5.2h-1.3a.7.7 0 01-.8-.8l-2.3-9.4-2.3 9.4a.8.8 0 01-.2.6l-.6.2zm18.8.4a8.3 8.3 0 01-2.2-.3l-1.7-.6a1.1 1.1 0 01-.5-.4c0-.1-.1-.3-.1-.4v-.8a.4.4 0 01.4-.4h.2l.4.2 1.6.5 1.8.2a4.1 4.1 0 002.1-.5 1.6 1.6 0 00.8-1.4 1.5 1.5 0 00-.4-1 3.5 3.5 0 00-1.5-.8l-2.1-.7a4.6 4.6 0 01-2.4-1.4 3.6 3.6 0 01-.7-2.2 2.9 2.9 0 01.4-1.6 2.9 2.9 0 011-1.2l1.6-.8 1.8-.2h1.9l.9.3.6.2c.2.1.3.3.4.4a.7.7 0 01.1.5v.7c0 .3-.1.4-.3.4a.6.6 0 01-.5-.2 8.8 8.8 0 00-2.9-.5 3.6 3.6 0 00-1.9.4 1.4 1.4 0 00-.7 1.3 1.4 1.4 0 00.5 1 2.9 2.9 0 001.6.8l2 .7a4 4 0 012.3 1.4 3.1 3.1 0 01.7 2 4.3 4.3 0 01-.4 1.7 3.5 3.5 0 01-1.1 1.3 3 3 0 01-1.6.8 4.9 4.9 0 01-2.1.6zM41.8 31.9C37 35.4 30 37.3 24 37.3A32.1 32.1 0 012.2 29c-.5-.4 0-1 .5-.6a44 44 0 0021.8 5.8 45.2 45.2 0 0016.6-3.4c.8-.4 1.5.5.7 1.1zm2-2.3c-.6-.8-4.1-.4-5.6-.2s-.6-.4-.2-.7c2.8-1.9 7.3-1.3 7.8-.7s-.1 5.2-2.7 7.4c-.4.3-.8.1-.6-.3s1.9-4.7 1.3-5.5z" />
        </g>
      </g>
    </svg>
  )
}

export function AivenSvgComponent(
  props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={50}
      height={50}
      viewBox="0 0 50 50"
      {...props}
      fill="currentColor"
    >
      <path
        d="m24.883 17.46 0.11 0C27.948 17.465 30.903 17.875 40.2 22.267l0.089 0.079c0.082 0.073 0.163 0.147 0.245 0.221l0.095 0.085c1.37 1.224 2.457 2.962 2.638 4.815 0.005 0.096 0.006 0.192 0.007 0.288l0.001 0.082q0 0.085 0.001 0.171c0 0.085 0.001 0.17 0.002 0.255 0.003 0.509 -0.055 1.006 -0.204 1.494l-0.026 0.088A16.2 16.2 0 0 1 42.967 30.1l-0.023 0.071c-0.272 0.824 -0.732 1.591 -1.277 2.262l-0.043 0.054A33.833 33.833 0 0 1 41.367 32.8c-0.183 -0.045 -0.366 -0.09 -0.548 -0.14 -0.541 -0.148 -1.085 -0.263 -1.649 -0.267l-0.083 -0.001c-0.832 -0.007 -0.832 -0.007 -1.654 0.107l-0.096 0.02c-0.965 0.199 -1.905 0.561 -2.704 1.147l-0.097 0.07c-0.814 0.597 -1.479 1.299 -2.003 2.163l-0.067 0.109C32.099 36.627 31.833 37.302 31.667 38c-1.985 0.513 -4.086 0.734 -6.133 0.767l-0.068 0.001C23.023 38.806 20.54 38.596 18.167 38l-0.017 -0.059c-0.242 -0.851 -0.57 -1.734 -1.117 -2.441l-0.067 -0.092c-0.762 -1.043 -1.735 -1.823 -2.9 -2.375l-0.107 -0.052c-0.786 -0.359 -1.683 -0.581 -2.549 -0.59l-0.081 -0.001c-0.913 -0.009 -1.738 0.081 -2.615 0.352 -0.083 0.024 -0.163 0.044 -0.248 0.056 -0.11 -0.076 -0.186 -0.195 -0.267 -0.3l-0.053 -0.068c-0.262 -0.342 -0.505 -0.688 -0.714 -1.065l-0.043 -0.076c-0.872 -1.541 -1.072 -3.27 -0.601 -4.97 0.33 -1.138 0.982 -2.141 1.775 -3.01a8.5 8.5 0 0 0 0.178 -0.204c0.252 -0.289 0.531 -0.559 0.825 -0.806l0.094 -0.081c0.281 -0.243 0.573 -0.467 0.873 -0.685l0.078 -0.057c0.379 -0.274 0.767 -0.527 1.172 -0.762a28.5 28.5 0 0 0 0.243 -0.143c2.287 -1.348 4.871 -2.163 12.857 -3.111M20.8 22.067c0.024 0.413 0.024 0.413 0.09 0.815l0.018 0.08C21.054 23.598 21.352 24.162 21.767 24.667l0.077 0.093c0.684 0.791 1.691 1.271 2.727 1.364C25.535 26.193 26.52 25.949 27.3 25.367l0.082 -0.06c0.402 -0.306 0.759 -0.672 1.018 -1.107l0.038 -0.064C28.819 23.484 29 22.822 29 22.067z"
        fill="#FE4D34"
      />
      <path
        d="m40 34 0.079 0.017c1.09 0.241 2.054 0.782 2.84 1.569a6.067 6.067 0 0 0 0.15 0.145c0.966 0.915 1.519 2.355 1.568 3.666 0.034 1.722 -0.521 3.19 -1.687 4.46 -0.348 0.361 -0.754 0.654 -1.184 0.909l-0.058 0.034c-0.463 0.272 -0.968 0.462 -1.488 0.595l-0.075 0.019c-0.431 0.103 -0.861 0.131 -1.302 0.129l-0.075 0c-0.658 -0.003 -1.241 -0.114 -1.869 -0.31 0.028 -0.153 0.12 -0.227 0.229 -0.329 0.535 -0.519 0.967 -1.158 1.271 -1.837l0.028 -0.063c0.315 -0.714 0.493 -1.54 0.205 -2.29 -0.17 -0.381 -0.464 -0.658 -0.849 -0.813 -0.558 -0.194 -1.194 -0.137 -1.751 0.033l-0.066 0.02c-0.938 0.296 -1.77 0.886 -2.443 1.591 -0.04 0.042 -0.082 0.082 -0.124 0.122h-0.067c-0.49 -1.402 -0.457 -3.008 0.178 -4.361 0.196 -0.405 0.411 -0.785 0.689 -1.139l0.07 -0.092c0.58 -0.741 1.318 -1.277 2.164 -1.675l0.112 -0.054c1.053 -0.484 2.328 -0.59 3.455 -0.346"
        fill="#FE4E33"
      />
      <path
        d="M14.851 35.339A13.967 13.967 0 0 1 15.1 35.567l0.072 0.066c0.934 0.885 1.581 2.28 1.633 3.567q0.001 0.072 0.001 0.145l0.001 0.079c0.006 0.797 -0.071 1.479 -0.307 2.243 -0.138 -0.063 -0.226 -0.156 -0.329 -0.265 -0.219 -0.224 -0.451 -0.418 -0.704 -0.602l-0.058 -0.042c-0.756 -0.544 -1.643 -0.974 -2.59 -0.968 -0.034 0 -0.067 0 -0.102 0.001 -0.464 0.008 -0.865 0.129 -1.217 0.443 -0.387 0.495 -0.487 1.015 -0.433 1.633 0.158 1.231 0.933 2.395 1.828 3.22C12.933 45.133 12.933 45.133 12.933 45.233c-1.57 0.49 -3.177 0.406 -4.654 -0.344 -0.516 -0.271 -0.961 -0.62 -1.379 -1.023l-0.071 -0.066c-1.009 -0.96 -1.598 -2.448 -1.636 -3.824 -0.03 -1.694 0.539 -3.184 1.708 -4.411 0.144 -0.147 0.302 -0.274 0.466 -0.399l0.094 -0.074c2.191 -1.699 5.31 -1.555 7.39 0.247"
        fill="#FE7304"
      />
      <path
        d="m17.923 4.556 0.07 0c0.387 0.002 0.762 0.027 1.14 0.11l0.078 0.017c0.822 0.182 1.588 0.537 2.255 1.05l0.092 0.069c0.433 0.339 0.83 0.743 1.142 1.198l0.041 0.059c0.885 1.305 1.205 2.886 0.926 4.436 -0.298 1.519 -1.186 2.864 -2.467 3.738 -0.859 0.563 -1.896 0.967 -2.933 0.973l-0.074 0.001c-1.026 0.008 -1.026 0.008 -1.493 -0.107l-0.082 -0.02C15.317 15.763 14.158 15.023 13.333 13.967l-0.078 -0.098C12.699 13.134 12.385 12.294 12.2 11.4l-0.025 -0.12c-0.245 -1.456 0.136 -3.025 0.975 -4.231 0.93 -1.302 2.288 -2.168 3.867 -2.435 0.302 -0.044 0.6 -0.059 0.906 -0.057M15.8 8.067l-0.078 0.07c-0.597 0.563 -0.931 1.383 -0.957 2.198 0.012 0.783 0.269 1.547 0.802 2.132l0.089 0.099c0.547 0.584 1.315 0.94 2.117 0.975 0.844 0.023 1.669 -0.241 2.298 -0.816 0.57 -0.547 1 -1.299 1.032 -2.106l-0.001 -0.067L21.1 10.433l-0.102 0.083c-0.525 0.393 -1.138 0.6 -1.799 0.507 -0.566 -0.102 -1.09 -0.371 -1.443 -0.834 -0.394 -0.578 -0.523 -1.177 -0.417 -1.864 0.071 -0.328 0.205 -0.623 0.41 -0.89 0.048 -0.065 0.083 -0.128 0.117 -0.202 -0.762 0 -1.511 0.319 -2.067 0.833"
        fill="#FD384F"
      />
      <path
        d="M35.556 5.847c0.102 0.087 0.199 0.178 0.294 0.272 0.052 0.051 0.105 0.102 0.158 0.152 0.372 0.359 0.665 0.747 0.924 1.196l0.065 0.109c0.328 0.566 0.535 1.213 0.635 1.858l0.012 0.074c0.222 1.494 -0.129 3.031 -1.012 4.259l-0.076 0.106C36.167 14.401 35.685 14.876 35.133 15.233l-0.06 0.039c-1.27 0.824 -2.832 1.146 -4.324 0.853A6.067 6.067 0 0 1 29.967 15.9c-0.04 -0.014 -0.08 -0.029 -0.121 -0.043 -0.915 -0.346 -1.795 -0.925 -2.412 -1.69l-0.075 -0.092c-0.999 -1.253 -1.436 -2.81 -1.266 -4.403 0.081 -0.645 0.264 -1.252 0.541 -1.838l0.031 -0.067C26.903 7.273 27.224 6.831 27.6 6.433q0.058 -0.067 0.115 -0.135c0.844 -0.959 2.111 -1.503 3.352 -1.698l0.12 -0.019c1.55 -0.182 3.164 0.271 4.369 1.266m-5.965 2.347c-0.63 0.662 -0.884 1.51 -0.869 2.405 0.03 0.804 0.422 1.505 0.977 2.067l0.073 0.074c0.576 0.548 1.382 0.813 2.168 0.804 0.89 -0.028 1.638 -0.384 2.26 -1.012l0.068 -0.067c0.48 -0.507 0.783 -1.278 0.767 -1.973L35.033 10.433l-0.047 0.037C34.454 10.88 33.88 11.091 33.2 11.033c-0.629 -0.088 -1.128 -0.397 -1.529 -0.881 -0.398 -0.545 -0.48 -1.168 -0.394 -1.827 0.075 -0.404 0.298 -0.778 0.557 -1.092 -0.841 -0.03 -1.645 0.399 -2.242 0.96"
        fill="#FD3453"
      />
      <path
        d="M43.5 22.767c1.684 -0.032 3.194 0.396 4.442 1.579L48.033 24.433l0.085 0.078c1.097 1.043 1.564 2.517 1.649 3.988v0.933l-4.2 0.033 0.4 0.367a8.867 8.867 0 0 1 0.3 0.367l0.082 0.101c0.219 0.271 0.392 0.557 0.551 0.866l0.032 0.061c0.681 1.325 0.8 2.939 0.361 4.359 -0.204 0.622 -0.488 1.197 -0.881 1.719a11.667 11.667 0 0 0 -0.145 0.2l-0.1 0.139c-0.016 0.022 -0.031 0.044 -0.047 0.067 -0.038 0.053 -0.079 0.103 -0.119 0.154h-0.067l-0.023 -0.073c-0.481 -1.5 -1.226 -2.803 -2.477 -3.794a19.7 19.7 0 0 1 -0.123 -0.102L43.233 33.833c0.018 -0.144 0.108 -0.241 0.194 -0.352 0.932 -1.246 1.526 -2.681 1.773 -4.215l0.013 -0.082c0.277 -1.789 -0.176 -3.639 -1.013 -5.218l-0.034 -0.065c-0.162 -0.304 -0.343 -0.592 -0.539 -0.876l-0.05 -0.073 -0.045 -0.065C43.5 22.833 43.5 22.833 43.5 22.767"
        fill="#FD3750"
      />
      <path
        d="M5.833 22.765q0.073 0 0.146 0 0.177 0.001 0.354 0.002a2.367 2.367 0 0 1 -0.149 0.264c-0.703 1.093 -1.231 2.233 -1.493 3.511l-0.015 0.074c-0.095 0.489 -0.122 0.975 -0.12 1.472l0 0.088c0.002 0.459 0.024 0.905 0.11 1.357l0.016 0.091c0.255 1.407 0.874 2.783 1.759 3.906 0.078 0.1 0.133 0.178 0.158 0.302l-0.085 0.072a120.5 120.5 0 0 0 -0.295 0.25 28.233 28.233 0 0 1 -0.126 0.106C5.719 34.58 5.388 34.935 5.1 35.333l-0.048 0.067C4.523 36.141 4.147 36.959 3.9 37.833h-0.1c-0.061 -0.068 -0.061 -0.068 -0.131 -0.165l-0.039 -0.054a20.4 20.4 0 0 1 -0.084 -0.118 14.767 14.767 0 0 0 -0.143 -0.196c-0.74 -1.01 -1.119 -2.188 -1.112 -3.44l0 -0.072c0.002 -0.392 0.025 -0.771 0.11 -1.155l0.017 -0.078C2.683 31.353 3.332 30.268 4.267 29.467L0.067 29.433c0 -1.851 0.244 -3.419 1.535 -4.796a2.833 2.833 0 0 0 0.133 -0.156c0.098 -0.121 0.212 -0.215 0.332 -0.314l0.1 -0.084c1.044 -0.856 2.318 -1.327 3.667 -1.318"
        fill="#FD6D0A"
      />
      <path
        d="m8.6 17 0.071 0.004c1.065 0.06 2.027 0.408 2.929 0.963l0.091 0.055 0.084 0.053 0.073 0.046c0.017 0.015 0.034 0.03 0.052 0.045v0.1l-0.064 0.032C10.896 18.774 9.998 19.319 9.167 19.967l-0.111 0.086C8.278 20.653 7.505 21.323 6.9 22.1a27.533 27.533 0 0 1 -0.185 0.223l-0.086 0.102L6.567 22.5c-0.094 -0.044 -0.177 -0.095 -0.26 -0.157l-0.074 -0.055 -0.08 -0.059 -0.084 -0.062c-0.236 -0.175 -0.47 -0.354 -0.704 -0.532a80.2 80.2 0 0 0 -0.679 -0.513 76.433 76.433 0 0 1 -0.611 -0.463A41.5 41.5 0 0 0 3.233 20.033c0.433 -0.92 1.339 -1.724 2.2 -2.233l0.064 -0.038C6.416 17.228 7.535 16.941 8.6 17"
        fill="#FC5529"
      />
      <path
        d="m44.2 17.7 0.062 0.033A5.133 5.133 0 0 1 45.067 18.267l0.056 0.045c0.499 0.405 0.882 0.867 1.259 1.386 0.042 0.057 0.088 0.111 0.135 0.164 0.05 0.072 0.05 0.072 0.043 0.137 -0.033 0.084 -0.068 0.113 -0.139 0.167l-0.072 0.055 -0.078 0.059 -0.081 0.062c-0.216 0.164 -0.434 0.324 -0.652 0.484 -0.182 0.133 -0.36 0.27 -0.537 0.408 -0.226 0.177 -0.456 0.35 -0.688 0.519 -0.243 0.178 -0.482 0.361 -0.72 0.545l-0.085 0.065 -0.075 0.058C43.367 22.467 43.367 22.467 43.267 22.5l-0.077 -0.09c-0.183 -0.214 -0.367 -0.427 -0.557 -0.636a8.767 8.767 0 0 1 -0.173 -0.199c-0.241 -0.276 -0.506 -0.542 -0.786 -0.779a12.2 12.2 0 0 1 -0.186 -0.161c-0.266 -0.234 -0.536 -0.458 -0.821 -0.668l-0.069 -0.051c-0.337 -0.248 -0.679 -0.489 -1.031 -0.716l-0.076 -0.049c-0.503 -0.323 -1.023 -0.617 -1.558 -0.884v-0.1a2.133 2.133 0 0 1 0.206 -0.15l0.068 -0.044C40.014 16.826 42.304 16.659 44.2 17.7"
        fill="#FC3453"
      />
      <path
        d="m35 35.3 0.1 0.033 -0.767 0.767 -0.067 -0.033c0.239 -0.262 0.48 -0.519 0.733 -0.767"
        fill="#BD3D27"
      />
      <path
        d="m4.2 29.5 0.1 0.033 -0.667 0.667 -0.067 -0.033 0.242 -0.258 0.069 -0.074 0.067 -0.072 0.061 -0.066A9.767 9.767 0 0 1 4.2 29.5"
        fill="#CB5C08"
      />
      <path
        d="m7.067 35.433 0.067 0.033 -0.533 0.533 -0.067 -0.033a110.4 110.4 0 0 1 0.229 -0.248l0.066 -0.071 0.063 -0.068 0.058 -0.063C7 35.467 7 35.467 7.067 35.433"
        fill="#C55F01"
      />
      <path
        d="M1.967 24.267c0 0.1 0 0.1 -0.043 0.154l-0.059 0.058 -0.064 0.063L1.733 24.606l-0.067 0.066A28.767 28.767 0 0 1 1.5 24.833l-0.067 -0.033 0.046 -0.045c0.091 -0.09 0.178 -0.177 0.258 -0.278 0.068 -0.084 0.143 -0.146 0.229 -0.21"
        fill="#E05F11"
      />
    </svg>
  )
}

export function BigquerySvgComponent(
  props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      width="50px"
      height="50px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <style>
          {".cls-1,.cls-2{fill:#aecbfa;fill-rule:evenodd}.cls-2{fill:#669df6}"}
        </style>
      </defs>
      <g data-name="Product Icons">
        <path
          className="cls-1"
          d="M6.73 10.83v2.63a4.91 4.91 0 001.71 1.74v-4.37z"
        />
        <path
          className="cls-2"
          d="M9.89 8.41v7.53A7.62 7.62 0 0011 16a8 8 0 001 0V8.41z"
        />
        <path className="cls-1" d="M13.64 11.86v3.29a5 5 0 001.7-1.82v-1.47z" />
        <path
          d="M17.74 16.32l-1.42 1.42a.42.42 0 000 .6l3.54 3.54a.42.42 0 00.59 0l1.43-1.43a.42.42 0 000-.59l-3.54-3.54a.42.42 0 00-.6 0"
          fill="#4285f4"
          fillRule="evenodd"
        />
        <path
          className="cls-2"
          d="M11 2a9 9 0 109 9 9 9 0 00-9-9m0 15.69A6.68 6.68 0 1117.69 11 6.68 6.68 0 0111 17.69"
        />
      </g>
    </svg>
  )
}

export function AzureSvgComponent(
  props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      width="50px"
      height="50px"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
    >
      <path
        d="M7.47 12.412l3.348-.592.031-.007-1.722-2.049a291.474 291.474 0 01-1.723-2.058c0-.01 1.779-4.909 1.789-4.926a788.95 788.95 0 012.934 5.066l2.95 5.115.023.039-10.948-.001 3.317-.587zM.9 11.788c0-.003.811-1.412 1.803-3.131L4.507 5.53l2.102-1.764C7.765 2.797 8.714 2 8.717 2a.37.37 0 01-.033.085L6.4 6.981l-2.24 4.808-1.63.002c-.897.001-1.63 0-1.63-.003z"
        fill="#0089D6"
      />
    </svg>
  )
}

export function GcpSvgComponent(
  props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      width="50px"
      height="50px"
      viewBox="0 -25 256 256"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid"
      {...props}
    >
      <path
        d="M170.252 56.819l22.253-22.253 1.483-9.37C153.437-11.677 88.976-7.496 52.42 33.92 42.267 45.423 34.734 59.764 30.717 74.573l7.97-1.123 44.505-7.34 3.436-3.513c19.797-21.742 53.27-24.667 76.128-6.168l7.496.39z"
        fill="#EA4335"
      />
      <path
        d="M224.205 73.918a100.249 100.249 0 00-30.217-48.722l-31.232 31.232a55.515 55.515 0 0120.379 44.037v5.544c15.35 0 27.797 12.445 27.797 27.796 0 15.352-12.446 27.485-27.797 27.485h-55.671l-5.466 5.934v33.34l5.466 5.231h55.67c39.93.311 72.553-31.494 72.864-71.424a72.303 72.303 0 00-31.793-60.453"
        fill="#4285F4"
      />
      <path
        d="M71.87 205.796h55.593V161.29H71.87a27.275 27.275 0 01-11.399-2.498l-7.887 2.42-22.409 22.253-1.952 7.574c12.567 9.489 27.9 14.825 43.647 14.757"
        fill="#34A853"
      />
      <path
        d="M71.87 61.425C31.94 61.664-.237 94.228.001 134.159a72.301 72.301 0 0028.222 56.88l32.248-32.246c-13.99-6.322-20.208-22.786-13.887-36.776 6.32-13.99 22.786-20.208 36.775-13.888a27.796 27.796 0 0113.887 13.888l32.248-32.248A72.224 72.224 0 0071.87 61.425"
        fill="#FBBC05"
      />
    </svg>
  )
}

export function ConfluentSvgComponent(
  props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>,
) {
  const { fill } = useSvgStyle()
  return (
    <svg
      fill={fill}
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="50px"
      height="50px"
      viewBox="0 0 43 43"
      xmlSpace="preserve"
      {...props}
    >
      <style>{`.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#${fill}}`}</style>
      <path
        className="st0"
        d="M30.8 22.7c1.1-.1 2.2-.1 3.3-.2v-.8c-1.1-.1-2.2-.1-3.3-.2l-3.3-.1c-1.9-.1-3.9-.1-5.8-.1 0-1.9 0-3.9-.1-5.8l-.1-3.3c-.1-1.1-.1-2.2-.2-3.3h-.9c-.1 1.1-.1 2.2-.2 3.3l-.1 3.3v2.7c-.4-.8-.7-1.7-1.1-2.5l-1.4-3c-.5-1-.9-2-1.4-3l-.8.3c.4 1.1.7 2.1 1.1 3.1l1.2 3.1c.3.9.7 1.7 1 2.6-.7-.6-1.3-1.3-2-1.9l-2.4-2.3c-.8-.7-1.6-1.5-2.5-2.2l-.7.7c.7.8 1.5 1.6 2.2 2.5l2.3 2.4c.6.7 1.3 1.3 1.9 2-.8-.3-1.7-.7-2.6-1l-3.1-1.2c-1-.4-2.1-.8-3.1-1.1l-.4.9c1 .5 2 .9 3 1.4l3 1.4c.8.4 1.7.7 2.5 1.1h-2.7l-3.3.1c-1.1.1-2.2.1-3.3.2v.9c1.1.1 2.2.1 3.3.2l3.3.1c2 .1 3.9.1 5.8.1 0 1.9 0 3.9.1 5.8l.1 3.3c.1 1.1.1 2.2.2 3.3h.8c.1-1.1.1-2.2.2-3.3l.1-3.3c0-.9 0-1.9.1-2.8.4.9.7 1.7 1.1 2.6l1.4 3c.5 1 .9 2 1.4 3l.8-.3c-.3-1.1-.7-2.1-1.1-3.1l-1-3.3c-.3-.9-.7-1.7-1-2.6.7.7 1.3 1.3 2 1.9l2.4 2.3c.8.7 1.6 1.5 2.5 2.2l.6-.6c-.7-.8-1.5-1.6-2.2-2.5l-2.3-2.4c-.6-.7-1.3-1.4-1.9-2 .9.3 1.7.7 2.6 1l3.1 1.2c1 .4 2.1.8 3.1 1.1l.3-.8c-1-.5-2-1-3-1.4l-3-1.4c-.9-.4-1.7-.8-2.6-1.1.9 0 1.9 0 2.8-.1l3.3-.1z"
      />
      <path
        className="st0"
        d="M21.5 43C9.6 43 0 33.4 0 21.5S9.6 0 21.5 0 43 9.6 43 21.5 33.4 43 21.5 43m0-41C10.8 2 2 10.8 2 21.5S10.8 41 21.5 41 41 32.2 41 21.5 32.2 2 21.5 2"
      />
    </svg>
  )
}

export function GcsSvgComponent(
  props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>,
) {
  const { fill } = useSvgStyle()
  return (
    <svg
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      height={50}
      width={50}
      viewBox="-19.20015 -28.483 166.4013 170.898"
      {...props}
    >
      <g transform="translate(0 -7.034)">
        <linearGradient
          y2={120.789}
          x2={64}
          y1={7.034}
          x1={64}
          gradientUnits="userSpaceOnUse"
          id="a"
        >
          <stop offset={0} stopColor="#4387fd" />
          <stop offset={1} stopColor="#4683ea" />
        </linearGradient>
        <path
          d="M27.79 115.217L1.54 69.749a11.499 11.499 0 010-11.499l26.25-45.467a11.5 11.5 0 019.96-5.75h52.5a11.5 11.5 0 019.959 5.75l26.25 45.467a11.499 11.499 0 010 11.5l-26.25 45.466a11.5 11.5 0 01-9.959 5.75h-52.5a11.499 11.499 0 01-9.96-5.75z"
          fill="url(#a)"
        />
      </g>
      <g transform="translate(0 -7.034)">
        <defs>
          <path
            d="M27.791 115.217L1.541 69.749a11.499 11.499 0 010-11.499l26.25-45.467a11.499 11.499 0 019.959-5.75h52.5a11.5 11.5 0 019.96 5.75l26.25 45.467a11.499 11.499 0 010 11.5l-26.25 45.466a11.499 11.499 0 01-9.96 5.75h-52.5a11.499 11.499 0 01-9.959-5.75z"
            id="b"
          />
        </defs>
        <clipPath id="c">
          <use height="100%" width="100%" xlinkHref="#b" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#c)"
          opacity={0.07}
          d="M49.313 53.875l-7.01 6.99 5.957 5.958-5.898 10.476 44.635 44.636 10.816.002L118.936 84 85.489 50.55z"
        />
      </g>
      <path
        d="M84.7 43.236H43.264c-.667 0-1.212.546-1.212 1.214v8.566c0 .666.546 1.212 1.212 1.212H84.7c.667 0 1.213-.546 1.213-1.212v-8.568c0-.666-.545-1.213-1.212-1.213m-6.416 7.976a2.484 2.484 0 01-2.477-2.48 2.475 2.475 0 012.477-2.477c1.37 0 2.48 1.103 2.48 2.477a2.48 2.48 0 01-2.48 2.48m6.415 8.491l-41.436.002c-.667 0-1.212.546-1.212 1.214v8.565c0 .666.546 1.213 1.212 1.213H84.7c.667 0 1.213-.547 1.213-1.213v-8.567c0-.666-.545-1.214-1.212-1.214m-6.416 7.976a2.483 2.483 0 01-2.477-2.48 2.475 2.475 0 012.477-2.477 2.48 2.48 0 110 4.956"
        fill="#fff"
      />
    </svg>
  )
}

export function WaterfallSvgComponent(
  props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 01-1.311-1.311C3 18.72 3 17.88 3 16.2V3m12 1v4m-4 0v4m-4 1v4M19 4v13"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
